import React from "react";

const PreviewBuilder = ({ previewComponent, index }) => {
  return (
    <React.Fragment>
      <div className="accordion-item mb-3" style={{ borderRadius: "5px" }}>
        <span
          className="accordion-header mb-0"
          id={`panelsStayOpen-heading${index}`}
        >
          <button
            data-testid="builder-preview-accordion-btn"
            className="accordion-button btn pb-2 pt-1 shadow-none collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#panelsStayOpen-collapse${index}`}
            aria-expanded="false"
            aria-controls={`panelsStayOpen-collapse${index}`}
            style={{
              backgroundColor: "#f2f2f2",
              color: "black",
              fontFamily: "Noto Sans",
            }}
          >
            <span className="col">{previewComponent.unique_name}</span>
            <span
              className="col float-end fs-6 fw-light text-end"
              style={{ color: "#5c5f62" }}
            >{`${previewComponent.products.length} Products`}</span>
          </button>
        </span>
        <div
          id={`panelsStayOpen-collapse${index}`}
          className="accordion-collapse collapse"
          aria-labelledby={`panelsStayOpen-heading${index}`}
        >
          <div className="accordion-body d-grid">
            {previewComponent.products &&
            previewComponent.products.length > 0 ? (
              previewComponent.products.map((i, index) => {
                return (
                  <span
                    key={index}
                    style={{ fontFamily: "Noto Sans" }}
                    className="mb-2"
                  >
                    {i}
                  </span>
                );
              })
            ) : (
              <p>No Products Found</p>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default PreviewBuilder;
